import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IrisHeaderComponent } from './components/header/header.component';
import { IrisHeaderNotificationsComponent } from './components/header-notifications/header-notifications.component';
import { IrisHeaderSearchComponent } from './components/header-search/header-search.component';
import { IrisHeaderProfileInfoComponent } from './components/header-profile-info/header-profile-info.component';
import { IrisHeaderDropdownMenuComponent } from './components/header-dropdown-menu/header-dropdown-menu.component';
import { IrisHeaderClockComponent } from './components/header-clock/header-clock.component';
import { IrisMainMenuService } from '@iris/common/services/main-menu.service';
import { IrisNotificationsUnlockModalComponent } from './components/header-notifications/notifications-unlock-modal/notifications-unlock-modal.component';
import { HeaderHelpComponent } from './components/header-help/header-help.component';
import { IrisHeaderSettingsComponent } from '@iris/modules/header/components/header-settings/header-settings.component';
import { IrisHeaderSearchResultCardTemplateModule } from '@iris/modules/header/components/header-search/search-results-cards/card-template';
import { IrisPreviewFileModule } from '@iris/common/modules/preview-file/preview-file.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IrisExternalCommonLibsModule } from '@iris/common/modules/external-common-libs/external-common-libs.module';
import { IrisTimeModule } from '@iris/common/modules/time';
import { IrisCommonPipesModule } from '@iris/common/modules/pipes-common/common-pipes.module';
import { HeaderTitleComponent } from './components/header-title/header-title.component';
import { MatMenuModule } from '@angular/material/menu';
import { IrisFilesService } from '@iris/common/modules/dms/services/files.service';
import { IrisUserWSComponent } from '@iris/common/modules/user-common/modules/user-ws/components/user-ws.component';
import {
  IrisUserComponent,
} from '@iris/common/modules/user-common/modules/sk-user-wrapper/components/sk-iris-user.component';
import { SafeHtmlPipe, SafeUrlPipe } from '@iris/common/modules/pipes-common/pipes';
import {
  IrisHeaderSearchResultForUserComponent,
} from '@iris/modules/header/components/header-search/search-results-cards/user/user.component';
import { StrakitButtonComponent, StrakitSelectComponent } from '@ngx-strakit/cdk/controls';
import { IrisSkSelectFieldDirective } from '@iris/common/modules/fields/sk-select-field/ng-select-field.sk.directive';
import { IrisProjectSkSelectDirective } from '@iris/common/modules/fields/project-sk-select/project-select.directive';
import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import {
  HeaderApplicationsMenuComponent,
} from '@iris/modules/header/components/header-applications-menu/header-applications-menu.component';
import {
  StrakitButtonPrefixDirective,
  SkModalContentComponent,
} from '@ngx-strakit/cdk';

@NgModule({
  imports: [
    IrisExternalCommonLibsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IrisUserWSComponent,
    IrisPreviewFileModule,
    RouterModule,
    SkModalContentComponent,
    IrisHeaderSearchResultCardTemplateModule,
    SafeHtmlPipe,
    IrisTimeModule,
    StrakitSelectComponent,
    IrisSkSelectFieldDirective,
    IrisProjectSkSelectDirective,
    IrisCommonPipesModule,
    MatMenuModule,
    IrisUserComponent,
    SafeUrlPipe,
    IrisHeaderSearchResultForUserComponent,
    CdkConnectedOverlay,
    CdkOverlayOrigin,
    HeaderApplicationsMenuComponent,
    StrakitButtonComponent,
    StrakitButtonPrefixDirective,
  ],
  declarations: [
    IrisHeaderComponent,
    IrisHeaderNotificationsComponent,
    IrisHeaderSearchComponent,
    IrisHeaderProfileInfoComponent,
    IrisHeaderDropdownMenuComponent,
    IrisHeaderClockComponent,
    IrisHeaderSettingsComponent,
    IrisNotificationsUnlockModalComponent,
    HeaderHelpComponent,
    HeaderTitleComponent,
  ],
  exports: [IrisHeaderComponent],
  providers: [
    IrisMainMenuService,
    IrisFilesService,
  ],
})
export class IrisHeaderModule {
}
